import { Component, computed, input, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { suggestEmail } from '@awo-care/email-validation';

@Component({
  selector: 'lib-email-suggestion-hint',
  standalone: true,
  template: `
    @if (suggestion()) {
      <button
        type="button"
        class="suggestion"
        (click)="apply()"
        data-testid="email-suggestion"
      >
        <span i18n="@@common.emailSuggestion.prefix">Meinten Sie</span>
        <strong>{{ suggestion() }}</strong
        ><span i18n="@@common.emailSuggestion.questionMark">?</span>
      </button>
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    :host {
      display: block;
    }

    .suggestion {
      display: inline-flex;
      align-items: center;
      gap: 0.3rem;
      margin-top: -0.5rem;
      margin-bottom: 0.75rem;
      padding: 0.4rem 0.6rem;
      background: #fff8e1;
      border: 1px solid #ffd54f;
      border-radius: 0.25rem;
      color: #5d4037;
      font-size: 0.85rem;
      cursor: pointer;
      text-align: left;

      &:hover {
        background: #ffecb3;
      }

      strong {
        color: #1565c0;
        text-decoration: underline;
      }
    }
  `,
})
export class EmailSuggestionHintComponent {
  email = input<string | null | undefined>('');

  private active = signal(false);

  suggestion = computed(() =>
    this.active() ? suggestEmail(this.email()) : null,
  );

  applied = output<string>();

  /** Auf Blur des Email-Inputs aufrufen, damit der Hint nicht während des Tippens triggert. */
  check(): void {
    this.active.set(true);
  }

  /** Auf Focus des Email-Inputs aufrufen, damit der Hint verschwindet, sobald der User wieder editiert. */
  reset(): void {
    this.active.set(false);
  }

  apply(): void {
    const value = this.suggestion();
    if (value) {
      this.applied.emit(value);
      this.active.set(false);
    }
  }
}
